import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuTableHead from '../../components/molecules/ChangeTicketMenuTableHead';
import MenuTableBody from '../../components/molecules/ChangeTicketMenuTableBody';
// import ExPagination from '../../components/molecules/ExPagination';
import TablePagination from '../../components/molecules/TablePagination';
import { divideTicketToNTicket } from '../../actions/Gochis';
import { sendLogin } from '../../auth/Auth';
import ValidationText from '../../components/atoms/ValidationText';
// import ChangeTicketToNButton from '../../components/atoms/ChangeTicketToNButton';
import ChangeToNDialog from '../../components/molecules/ChangeToNDialog';
import ContentDialog from '../../components/molecules/ContentDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left',
    margin: '20px',
    position: 'absolute',
    left: '200px'
  },
  left: {
    textAlign: 'left',
    float: 'left',
    marginBottom: '4rem'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.list,
      totalCount: 1000,
      offset: 1
    }),
    dispatch => ({
      actions: bindActionCreators({ divideTicketToNTicket }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityId', 'setIdentityId', null),
  withState('shopId', 'setShopId', null),
  withState('sealCertificate', 'setSealCertificate', null),
  withState('businessLicense', 'setBusinessLicense', null),
  withState('other', 'setOther', null),
  withState('note', 'setNote', null),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('menuId', 'setMenuId', null),
  withState('menuNameChange', 'setMenuNameChange', null),
  withState('includedTaxPriceChange', 'setIncludedTaxPriceChange', null),
  withState('quantity', 'setQuantity', null),
  withState('couponNumberError', 'setCouponNumberError', ''),
  withState('menuIdChangeError', 'setMenuIdChangeError', ''),
  withState('openChangeToN', 'updateOpenChangeToN', false),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => event => {
      // props.setRowsPerPage(rowsPerPage);
      props.handleChangePage(event, 0);
      props.setRowsPerPage(event.target.value);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    progress,
    menus,
    menuId,
    setMenuId,
    menuNameChange,
    setMenuNameChange,
    includedTaxPriceChange,
    setIncludedTaxPriceChange,
    page,
    totalCount,
    rowsPerPage,
    setTargetRowId,
    handleChangePage,
    handleChangeRowsPerPage,
    offset,
    selectedPage,
    gochiBillId,
    firstMenuName,
    firstPrice,
    firstCouponCount,
    quantity,
    setQuantity,
    setFullMessage,
    couponNumberError,
    setCouponNumberError,
    menuIdChangeError,
    setMenuIdChangeError,
    actions,
    openChangeToN,
    updateOpenChangeToN,
    setPage,
    updateOpenFullMessage,
    openFullMessage,
    fullMessage
  }) => {
    // actions,
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const setMenuIdChange = menuIdChange => {
      setMenuId(menuIdChange);
    };

    const setMenuName = menuName => {
      setMenuNameChange(menuName);
    };

    const setIncludedTaxPrice = price => {
      setIncludedTaxPriceChange(price);
    };

    const moreMessageAction = msg => {
      setFullMessage(msg);
      updateOpenFullMessage(true);
    };

    useEffect(() => {
      setQuantity('');
      setMenuId('');
      setPage(0);
      setMenuIdChangeError('');
      setCouponNumberError('');
    }, [menus]);

    // console.log('menu', menus);

    const validCouponNumber = v => {
      const value = v ? v.trim() : '';
      if (value === '') {
        setCouponNumberError('必須項目です。');
        return 1;
      }
      if (!/^([1-9]|[1-9][0-9])$/.test(value)) {
        setCouponNumberError('枚数を１～９９で入力してください。');
        return 1;
      }
      setCouponNumberError('');
      return 0;
    };

    const validMenuIdChange = v => {
      const value = v;
      if (!value) {
        setMenuIdChangeError('メニューを選択してください。');
        return 1;
      }
      setMenuIdChangeError('');
      return 0;
    };

    const changeToNAction = params => {
      progress.updateOpenProgress(true);
      actions
        .divideTicketToNTicket(params)
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.type === 'CHANGE_TICKET_TO_N_SUCCESS') {
            alert('分割できました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const cancelAction = () => updateOpenChangeToN(false);
    // const changeAction = () => {
    //   updateOpenChangeToN(false);
    //   onClickAction({ gochiBillId, menuId, quantity });
    // };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <MenuTableHead roles={roles} />
            <MenuTableBody
              menus={menus}
              setMenuIdChange={setMenuIdChange}
              setMenuName={setMenuName}
              setIncludedTaxPrice={setIncludedTaxPrice}
              emptyRows={emptyRows}
              messageViewAction={moreMessageAction}
              page={page}
              rowsPerPage={rowsPerPage}
              setTargetRowId={setTargetRowId}
              roles={roles}
            />
          </Table>
        </div>
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <TablePagination
              searchResults={menus}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={menus ? menus.length : totalCount}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        )}
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
        <div className={classes.left}>
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TextField
              label="枚数"
              className={classes.textField}
              margin="normal"
              value={quantity}
              onChange={e => {
                setQuantity(e.target.value);
                // setSearchSortKey('abc');
              }}
            />
          )}
          <ValidationText message={couponNumberError} />
          <ValidationText message={menuIdChangeError} />
        </div>
        <div className={classes.buttonGroupLeft}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() =>
              validCouponNumber(quantity) + validMenuIdChange(menuId) === 0
                ? updateOpenChangeToN(true)
                : null
            }
          >
            確定
          </Button>
          <ChangeToNDialog
            openChangeNonUse={openChangeToN}
            updateOpenChangeNonUse={openChangeToN}
            cancelAction={cancelAction}
            changeAction={() => {
              updateOpenChangeToN(false);
              changeToNAction({
                gochiBillId: parseInt(gochiBillId, 10),
                menuId,
                quantity: parseInt(quantity, 10)
              });
            }}
            gochiBillId={gochiBillId}
            firstMenuName={firstMenuName}
            firstPrice={firstPrice}
            firstCouponCount={firstCouponCount}
            menuId={menuId}
            menuNameChange={menuNameChange}
            includedTaxPriceChange={includedTaxPriceChange}
            quantity={quantity}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
